import refetchMetadata from '../actions/refetchMetadata'
import createSnackbar from 'modules/App/factories/createSnackbar'

export default [
  refetchMetadata,
  createSnackbar({ key: 'bms.refetchMetadata' }, 'success')
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/refetchMetadata.js